var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircleIndicator(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.36417 4.12674C1.85429 2.91381 2.80028 1.94128 3.99918 1.41778C5.19808 0.894282 6.55441 0.861513 7.7772 1.3265C8.99998 1.79149 9.99183 2.71721 10.54 3.90505C11.0881 5.0929 11.1488 6.44826 10.7092 7.68038C10.2695 8.9125 9.36446 9.92324 8.18818 10.4958C7.0119 11.0683 5.65808 11.157 4.41715 10.7428C3.17622 10.3287 2.14702 9.4447 1.55035 8.28048C0.953677 7.11626 0.837056 5.76456 1.2255 4.51535",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleIndicator);
export default __webpack_public_path__ + "static/media/circle_indicator.6ba76e249c1dbeaeca5d3e942f9f4c8a.svg";
export { ForwardRef as ReactComponent };